import type { GetAway } from '~/core/ts/entity/GetAway'
import type { Location } from '~/core/ts/entity/Location'
import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'
import { translate } from '~/core/ts/util/translate'


export function getGetAwayListMetadata(url: string, location?: Location | null) {
  const { pageHeadTitle, metaDescription, metaTitle } = getListTitleAndDescription(location)
  const combtitle = pageHeadTitle + ' | Spalopia.com'

  const builder = HeadMetaBuilder.create()
    .withTitle(combtitle)
    .withMetaTitle(metaTitle)
    .withMetaDescription(metaDescription)
    .withOpenGraphMeta(combtitle, metaDescription)
    .withTwitterMeta(combtitle, metaDescription)
    .withLink('canonical', url)

  return builder.get()
}

export function getListTitleAndDescription(location?: Location | null) {
  const title = translate(location ? {
    es: `Escapadas románticas en Hoteles con Spa en ${location.label}`,
    pt : `Escapadinhas românticas em hotéis com Spa em ${location.label}`,
  } : {
    es: `Escapadas románticas en Hoteles con Spa`,
    pt : `Escapadinhas românticas em hotéis com Spa`,
  })

  const metaTitle = translate(location ? {
    es: `Escapada romántica en hoteles con Spa de ${location.label}`,
    pt: `Escapadela romântica em hotéis com Spa em ${location.label}`,
  } : {
    es: 'Escapada romántica en hoteles con Spa al mejor precio',
    pt: 'Escapadela romântica em hotéis com Spa ao melhor preço',
  })

  const metaDescription = translate(location ? {
    es: `Gran selección de escapadas románticas en ${location.label}. Hoteles con Spa incluido para disfrutar y recargar pilas en pareja`,
    pt: `Grande seleção de escapadelas românticas em ${location.label}. Hotéis com Spa incluído para desfrutar e recarregar as baterias a dois.`,
  }:{
    es: 'En Spalopia tienes una gran selección de escapadas románticas en Hoteles con Spa incluido para disfrutar y recargar pilas en pareja.',
    pt: 'Na Spalopia tem uma grande seleção de escapadelas românticas em Hotéis com Spa incluído para desfrutar e recarregar baterias a dois.',
  })

  const meta = {
    // Título usado en <title></title>
    pageHeadTitle: title,

    title,
    metaTitle,

    metaDescription,
  }

  return meta
}

export function getGetAwayDetailMetadata(url: string, getAway: GetAway) {
  const { pageHeadTitle, metaDescription, metaTitle } = getDetailTitleAndDescription(getAway)
  const combtitle = pageHeadTitle + ' | Spalopia.com'

  const builder = HeadMetaBuilder.create()
    .withTitle(combtitle)
    .withMetaTitle(metaTitle)
    .withMetaDescription(metaDescription)
    .withOpenGraphMeta(combtitle, metaDescription)
    .withTwitterMeta(combtitle, metaDescription)
    .withLink('canonical', url)

  return builder.get()
}

export function getDetailTitleAndDescription(getAway: GetAway) {
  const hotelName = getAway.hotel.name
  const getAwayName = translate(getAway.texts).name

  const title = translate({
    es: `${getAwayName} en ${hotelName}`,
    pt: `${getAwayName} em ${hotelName}`,
  })

  const description = translate({
    es: `Disfruta de una escapada romántica con Spa en ${hotelName} de España al mejor precio Disfruta y recarga pilas en pareja con Spalopia`,
    pt: `Desfrute de uma escapadela romântica com Spa no ${hotelName} de España ao melhor preço Desfrute e recarregue as suas baterias com o seu parceiro com Spalopia`,
  })

  const meta = {
    // Título usado en <title></title>
    pageHeadTitle: title,

    title,
    metaTitle: title,

    metaDescription: description,
  }

  return meta
}


